import React from 'react';
import styled from 'styled-components';
import Flex from '/imports/core/ui/atoms/Flex';

import { FreeAccountIcon } from '/imports/dashboard/ui/assets';
import { getJobTrackRoute } from '/lib/helpers';
import Link, { Push } from '/components/Link';
import useIntl from '/imports/core/api/useIntl';
import { useResponsive } from '/imports/core/api/responsiveContext';
import { useAccount } from 'imports/core/api/accounts/accountContext';

const CancelSubscriptionNotFound = () => {
  const { t, locale } = useIntl();
  const { host } = useResponsive();
  const { currentUser } = useAccount();
  const { href, as } = getJobTrackRoute(host, 'resumes');

  return (
    <MainWrapper $fullWidth $alignItems="center" justifyContent="center">
      <InformationSection direction="column" $alignItems="center">
        <FreeAccountIcon width="80px" />
        <SuccessTitle>{t('contact.cancel_success_title')}</SuccessTitle>
        <SuccessDesc>{t('contact.cancel_success_description')}</SuccessDesc>
        <LinkWrapper>
          {!!currentUser ? (
            <Link href={href} as={as} style={{ textDecoration: 'none' }}>
              <StyledLink>{t('contact.cancel_success_resume_builder')}</StyledLink>
            </Link>
          ) : (
            <ResumeBuilderutton style={{ textDecoration: 'none' }} onClick={() => Push('/', locale)}>
              <StyledLink>{t('contact.cancel_success_resume_builder')}</StyledLink>
            </ResumeBuilderutton>
          )}
        </LinkWrapper>
      </InformationSection>
    </MainWrapper>
  );
};

const InformationSection = styled(Flex)`
  gap: 10px;
`;

const MainWrapper = styled(Flex)`
  min-height: calc(100vh - 181px);
  padding: 30px;
  background-color: #f1f0f2;

  @media (max-width: 980px) {
    margin-top: 75px;
  }

  @media (max-width: 550px) {
    padding: 30px 15px;
  }
`;

const SuccessTitle = styled.div`
  font-family: TTCommons;
  font-size: 32px;
  font-weight: 600;
  color: #282b32;
  text-align: center;
`;

const ResumeBuilderutton = styled.button`
  border: none;
  outline: none;
`;

const SuccessDesc = styled.div`
  font-family: TTCommons;
  font-size: 20px;
  line-height: 1.37;
  color: #282b32;
  text-align: center;
`;

const StyledLink = styled.div`
  border-radius: 3px;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 21px;
  border-radius: 3px;
  background-color: #1688fe;
  font-family: TTCommons;
  font-size: 18px;
  font-weight: 500;
  color: var(--light-values-white);
  border-color: #1688fe;
  cursor: pointer;
`;

const LinkWrapper = styled.div`
  display: flex;
  margin-top: 15px;
`;
export default CancelSubscriptionNotFound;
